module.exports = __webpack_public_path__ + "media/images/landkit/avatars/avatar-5-75d61b0037cbceb83deaff7cb081adb4.jpg";